// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9683341d","453":"f58883d4","553":"9be9491f"}[chunkId] + ".chunk.js";
};